import React from 'react'

export default function Download({ className }) {
  return (
    <svg viewBox="0 0 17 18" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M15.576 17.486H1.03a.996.996 0 01-1.007-.985V6.215A.996.996 0 011.03 5.23h2.506a.996.996 0 011.007.985.996.996 0 01-1.007.985H2.037v8.316h12.532V7.2h-1.375a.996.996 0 01-1.007-.985.996.996 0 011.007-.985h2.382a.996.996 0 011.007.985v10.286a.996.996 0 01-1.007.985zm-6.56-5.052l-.002.001-.711.696-.712-.696-.001-.001-3.766-3.683 1.424-1.393L7.296 9.36V1.093A.996.996 0 018.303.108a.996.996 0 011.007.985V9.36l2.047-2.002 1.424 1.393-3.765 3.683z"
      />
    </svg>
  )
}
